import axios from "axios";
//import config from "./config";
import { deckHerosApi as baseUrl, realGamesApi, OPERATOR_ID } from '../configs/const';
import * as serviceContext from '../services/serviceContext';

export async function getToken() {
    const url = `${baseUrl}/sso`;
    try {
      let token = JSON.parse(localStorage.getItem("userAuthDetail")).token;
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': OPERATOR_ID
      }
      const res = await axios.post(url, null, { headers: headers });
      return res;
    } catch (e) {
      // console.log(e);
      return false;
    }
  }

  export async function realGamesLaunchReport(reporturl) {
    const url = `${realGamesApi}/launch/report/${reporturl}`;
    try {
      let token = JSON.parse(localStorage.getItem("userAuthDetail")).token;
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': OPERATOR_ID
      }
      const response = await serviceContext.get(url, null, { headers: headers });
      if (response.hasError === true) {
        return false;
      }
      else {
          const res = response.json();
          return res;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  }